import { colors } from './colors';
import { radius } from './radius';
import { spacing } from './spacing';
import { typography } from './typography';

export const buttons = {
  variants: {
    primary: {
      background: colors.primary,
      color: colors.textOnPrimary,
      border: 'none',
      hoverBackground: colors.primaryDark,
    },
    secondary: {
      background: colors.primaryLight,
      color: colors.primary,
      border: 'none',
      hoverBackground: '#BFD7FF',
    },
    outline: {
      background: 'transparent',
      color: colors.primary,
      border: `1px solid ${colors.border}`,
      hoverBackground: colors.background,
    },
    ghost: {
      background: 'transparent',
      color: colors.primary,
      border: 'none',
      hoverBackground: colors.background,
    },
    danger: {
      background: colors.errorText,
      color: colors.textOnPrimary,
      border: 'none',
      hoverBackground: '#901212',
    }
  },
  sizes: {
    sm: {
      padding: `${spacing.xs} ${spacing.sm}`,
      fontSize: typography.fontSize.xs,
      height: '36px',
    },
    md: {
      padding: `${spacing.sm} ${spacing.md}`,
      fontSize: typography.fontSize.sm,
      height: '48px', // Complies with 48px touch target
    },
    lg: {
      padding: `${spacing.md} ${spacing.lg}`,
      fontSize: typography.fontSize.base,
      height: '56px',
    }
  },
  borderRadius: radius.md,
};

export default buttons;
